import { render, staticRenderFns } from "./IzvestajNaplata.vue?vue&type=template&id=5a28a9e0&scoped=true&"
import script from "./IzvestajNaplata.vue?vue&type=script&lang=js&"
export * from "./IzvestajNaplata.vue?vue&type=script&lang=js&"
import style1 from "./IzvestajNaplata.vue?vue&type=style&index=1&id=5a28a9e0&prod&scoped=true&lang=css&"
import style2 from "./IzvestajNaplata.vue?vue&type=style&index=2&id=5a28a9e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a28a9e0",
  null
  
)

export default component.exports